import { ButtonTypeMap, SvgIcon } from '@mui/material';
import {
  ActionButton,
  type ActionButtonProps,
  ActionIconButton,
  type ActionIconButtonProps,
} from '@/components/buttons';
import { ReactComponent as BindIcon } from '@/assets/icons-2.0/link.svg';
import { OverridableComponent } from '@mui/material/OverridableComponent';

export type BindActionIconButtonProps = Omit<ActionIconButtonProps, 'children'>;

export const BindActionIconButton: OverridableComponent<ButtonTypeMap<BindActionIconButtonProps>> = (
  props: BindActionIconButtonProps,
) => (
  <ActionIconButton title="Привязать" {...props}>
    <SvgIcon component={BindIcon} inheritViewBox />
  </ActionIconButton>
);

export type BindActionButtonButtonProps = ActionButtonProps;

export const BindActionButton: OverridableComponent<ButtonTypeMap<BindActionButtonButtonProps>> = (
  props: BindActionButtonButtonProps,
) => {
  const { children = 'Привязка' } = props;

  return (
    <ActionButton startIcon={<SvgIcon component={BindIcon} inheritViewBox fontSize="small" />} {...props}>
      {children}
    </ActionButton>
  );
};
